module.exports = __webpack_public_path__ + "assets/img/banner03_m.2c9c4096.png";